/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationDemographyOfferQuery from '../graphql/queries/GetSimulationDemographyOfferQuery.js';

const useGetSimulationDemographyOfferQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationDemographyOfferQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationDemographyOffer: R.omit(['__typename'], data?.getSimulationDemographyOffer_simulation_demography || {})
  };
};

export default useGetSimulationDemographyOfferQuery;
